import "src/types/window";
import type { dtrum } from "@dynatrace/dtrum-api-types/dtrum";
import { CreditDecision } from "src/pages/form-page/make-credit-decision/make-credit-decision.types";

const waitForDtrum = (timeoutMs = 10000): Promise<dtrum> => {
    return new Promise((resolve, reject) => {
        if (window?.dtrum) {
            resolve(window.dtrum);
            return;
        }

        const start = Date.now();
        const checkForDynatraceInterval = setInterval(() => {
            if (window?.dtrum) {
                clearInterval(checkForDynatraceInterval);
                resolve(window.dtrum);
            } else if (Date.now() - start >= timeoutMs) {
                clearInterval(checkForDynatraceInterval);
                reject(new Error("Dynatrace did not load within timeout"));
            }
        }, 200);
    });
};

export const logCreditDecisionSuccess = (correlationId: string, creditDecision: CreditDecision) => {
    if (window.dtrum) {
        const shortStringProps = {
            credit_decision: creditDecision.decision === "APPROVED" ? "accept" : "decline",
            x_correlation_id: correlationId,
        };

        const id = window.dtrum.enterAction("credit_decision_received");
        window.dtrum.addActionProperties(id, {}, {}, shortStringProps, {});
        window.dtrum.leaveAction(id);
    }
};

export const logCreditDecisionFailure = (correlationId: string, error: Error) => {
    if (window.dtrum) {
        const shortStringProps = {
            x_correlation_id: correlationId,
        };

        const id = window.dtrum.enterAction("credit_decision_failed");
        window.dtrum.addActionProperties(id, {}, {}, shortStringProps, {});
        window.dtrum.reportError(error);
        window.dtrum.reportCustomError("failed_submission", error.message, error.stack);
        window.dtrum.leaveAction(id);
    }
};

export const logAuthGuardFailure = (correlationId: string) => {
    waitForDtrum()
        .then((dtrum) => {
            const shortStringProps = {
                x_correlation_id: correlationId,
            };

            const id = dtrum.enterAction("auth_guard_failed");
            dtrum.addActionProperties(id, {}, {}, shortStringProps, {});
            dtrum.leaveAction(id);
        })
        .catch((err) => {
            console.warn("logAuthGuardFailure: could not send Dynatrace event.", err);
        });
};
